import { SaveButton } from "components/Buttons"
import {
  CheckboxField,
  CustomImageField,
  TextField,
} from "components/RenderInput"
import React from "react"
import { Card, CardBody, CardHeader, Col, Row } from "reactstrap"
import { Field } from "redux-form"

const WebpageTab = () => {
  return (
    <React.Fragment>
      <Card>
        <CardHeader>
          <h4>WEB PAGE</h4>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xs="auto" className="mt-2">
              <label>Web Page URL:</label>
            </Col>
            <Col xs="auto">
              <SaveButton type="button" content="Copy" />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs="auto">
              <Field
                component={CheckboxField}
                name="displayBanner"
                label="Display Information on Banner Image"
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col xs="auto" className="mt-2">
              <label>Upload Banner Image (1400px x 500px):</label>
            </Col>
            <Col>
              <Field name="bannerImage" component={CustomImageField} />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default WebpageTab
